'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPhoneOutline = function TiPhoneOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 6.1l-3-3c-0.9-0.9-2.2-1.4-3.5-1.4s-2.6 0.5-3.6 1.4l-2.6 2.7c-1.9 1.9-1.9 5.1 0 7l2.3 2.3-7 7-2.3-2.3c-0.9-0.9-2.2-1.5-3.5-1.5s-2.6 0.6-3.5 1.5l-2.7 2.6c-1.9 2-1.9 5.2 0 7.1l3 3c0.8 0.8 3 2.6 6.9 2.6 4.6 0 9.5-2.6 14.5-7.6 10.4-10.4 8-18.3 5-21.4z m-10.3 2l2.6-2.6c0.3-0.3 0.8-0.5 1.2-0.5s0.8 0.2 1.2 0.5l1.8 1.8-5 5-1.8-1.8c-0.7-0.7-0.7-1.7 0-2.4z m-16.7 19.1c-0.7-0.7-0.7-1.7 0-2.4l2.6-2.6c0.4-0.4 0.8-0.5 1.2-0.5s0.9 0.1 1.2 0.5l1.8 1.8-5 5-1.8-1.8z m19.6-2.1c-5.1 5.2-9.2 6.6-12.1 6.6-2.3 0-3.8-0.8-4.5-1.6 0 0 5-5 5-5l0.5 0.5c0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5l9.3-9.3c0.7-0.6 0.7-1.7 0-2.3l-0.5-0.5 5-5c1.7 1.6 4.2 7.5-5 16.6z' })
        )
    );
};

exports.default = TiPhoneOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/phone-outline.js
// module id = 2138
// module chunks = 0